<template>
  <div class="container-fluid">
    <div
      v-for="attribute in errors"
      v-bind:key="attribute"
      class="alert alert-danger"
    >
      <div v-for="error in attribute" v-bind:key="error">
        {{ error }}
      </div>
    </div>
    <h4 class="m-3">Изменение раздела статей</h4>
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      id="uploadForm"
      name="uploadForm"
      enctype="multipart/form-data"
    >
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <!-- <el-form-item label="Slug">
        <el-input v-model="form.slug"></el-input>
      </el-form-item> -->
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="(e) => storeArticleSection(e)"
          >Добавить</el-button
        >
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "../../store/mutation-types.js";

export default {
  name: "BannerCreate",
  data: function () {
    return {
      form: {
        title: "",
        slug: "",
        sort: "",
        activity: true,
      },
      errors: [],
      status: 0,
    };
  },
  mounted() {
    this.form = this.$store.getters.currentCategory;

    if (!this.form.id) {
      this.$store.commit(SETPRELOADER_STATE, true);

      this.getArticleSection();
    }
  },
  methods: {
    back() {
      this.$router.push("/article-sections");
    },
    getArticleSection() {
      axios
        .get(`/blog/section/${this.$route.params.id}`)
        .then((response) => {
          this.$store.commit(SETPRELOADER_STATE, false);

          this.form = response.data;
        })
        .catch((errors) => {
          this.$store.commit(SETPRELOADER_STATE, false);

          this.errors = errors.response.data.errors;

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    storeArticleSection(e) {
      let data = {
        title: this.form.title,
        slug: this.form.slug,
        activity: this.form.activity,
        sort: this.form.sort,
      };

      const t = e.target;

      t.style.pointerEvents = "none";

      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .post(`blog/section/${this.$route.params.id}`, data)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          t.style.pointerEvents = "all";

          this.status = response.status;
          this.$router.push("/article-sections");
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          t.style.pointerEvents = "all";

          this.errors = errors.response.data.errors;
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
  },
};
</script>

<style scoped>
</style>